import script from "./grid-card.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__